import React, {PropTypes} from 'react';
import {connect} from 'react-redux';
import {Link} from 'react-router';

import * as locations from '../../../../constants/dropdown';
import {messageTextValidation, nameValidation, emailValidation, phoneValidation} from '../../../../utils/itemValidation';

import * as commonActionCreators from '../../../../actions/common';
let allActionCreators = Object.assign({}, commonActionCreators);

import RhinoSelect from '../../../common/inputs/RhinoSelect';


class Earring2022 extends React.Component {

	static propTypes = {
		location: PropTypes.object
	};

	static contextTypes = {
		store: PropTypes.any,
		router: React.PropTypes.object.isRequired
	};

	constructor(props) {
		super(props);

		const firstEntry = [{display: 'Location*', 'value': ''}];
		const firstEntryNotReq = [{display: 'Location', 'value': ''}];
    const finalEntry = [{display: 'Other', 'value': 'online@diamondsdirect.com'}];

    let newArray= firstEntryNotReq.concat(locations.locations).concat(finalEntry);

		this.state = {
			locations: newArray,
			inputName: '',
			inputEmail: '',
			inputPhone: '',
			inputLocation: '',
			inputMessage: '',
			designerLocation: '',
			errorName: null,
			errorEmail: null,
			errorPhone: null,
			errorLocation: null,
			errorMessage: null,
			errorDesignerLocation: null,
		};
	}

	componentDidMount() {
		// this.giftsNav();
	}

	internalNav(page) {
		this.context.router.push('/' + page);
	}

	externalNav(page) {
		window.location.href = '/' + page;
	}

	openNew(page) {
		let win = window.open(page, '_blank');
		win.focus();
	}

	openIntercom() {
    acquireIO.max();
  }

	getLocationDesigners() {
		return [];
	}

	changeName(evt) {
		this.setState({ inputName: evt.target.value }, () => {
			if(this.state.errorName && !nameValidation(this.state.inputName)) {
				this.setState({ errorName: null });
			}
		});
	}

	changeEmail(evt) {
		this.setState({ inputEmail: evt.target.value }, () => {
			if(this.state.errorEmail && !emailValidation(this.state.inputEmail)) {
				this.setState({ errorEmail: null });
			}
		});
	}

	changePhone(evt) {
		this.setState({ inputPhone: evt.target.value }, () => {
			if(this.state.errorPhone && !phoneValidation(this.state.inputPhone)) {
				this.setState({ errorPhone: null });
			}
		});
	}

	changeLocation(evt) {
		this.setState({ inputLocation: evt.target.value}, () => {
			if(this.state.errorLocation !== false && this.state.inputLocation !== '') {
				this.setState({errorLocation: null});
			}
		});
	}

	changeDesigner(evt) {
		this.setState({ inputDesigner: evt.target.value });
	}

	changeDesignerLocation(evt) {
		this.setState({ designerLocation: evt.target.value });
	}

	submitContactRequest() {
		if(this.validateAll()) {

			let contactData = {
				full_name: this.state.inputName,
				email: this.state.inputEmail,
				phone: this.state.inputPhone,
				location: this.state.inputLocation,
			}

			this.props.commonSummerContactRequest(contactData);
			// this.props.commonAlert('One of our diamond experts will be in touch shortly.', 'Continue');
			this.props.commonAlert('Thank you for submitting a request! A member of our team will follow up with you shortly.', 'Continue', 'helping', '');
			this.setState({
				inputName: '',
				inputEmail: '',
				inputPhone: '',
				inputLocation: '',
				errorName: null,
				errorEmail: null,
				errorPhone: null,
				errorLocation: null,
			});
		}
	}

	validateAll() {

    let hasErrors = true;
    
    // Required params
    let nameError = nameValidation(this.state.inputName);
    let emailError = emailValidation(this.state.inputEmail);
    let locationError = nameValidation(this.state.inputLocation);

    // Optional params
    let phoneError = null;
    if(this.state.inputPhone) {
      phoneError = phoneValidation(this.state.inputPhone);
    }

    if(nameError === null &&
       emailError === null &&
       phoneError === null &&
       locationError === null) {
      hasErrors = false;
    }

    this.setState({
      errorName: nameError,
      errorEmail: emailError,
      errorPhone: phoneError,
      errorLocation: locationError,
    }, () => {
    	console.log(this.state);
    });

    return !hasErrors;
  }

  getShowDates(code) {
  	for(const l of this.state.designerLocationArray) {
  		if(l.value === code) {
  			return l.dates;
  		}
  	}
  	return '';
  }

  getShowLink(code) {
  	for(const l of this.state.designerLocationArray) {
  		if(l.value === code) {
  			return l.page;
  		}
  	}
  	return '';
  }

  designerNav(page) {
  	if(!page) { return; }
  	this.internalNav(page);
  }

  giftsNav(page) {
  	window.location.href='https://gifts.diamondsdirect.com';
  }

	render() {

		return <div className='Earring2022'>

			<div className='headerSection'>
				<div className='headerSectionWrapper'>
					<img className='desktop600' src='https://ddw2.diamondsdirect.com/img/promopages/earring2022/lander/header.jpg' />
					<img className='mobile600' src='https://ddw2.diamondsdirect.com/img/promopages/earring2022/lander/header_m.jpg' />
					<button type='button' className='shopButton' onClick={() => this.internalNav('gallery/engagement-rings')} style={{ display: 'none' }}>Shop Now</button>
				</div>
			</div>

			<div className='shopSection' style={{ display: 'none' }}>
				<div className='shopButtonWrapper'>
					<button type='button' className='shopButton'>Shop Online Now</button>
				</div>
				<div className='shopTilesWrapper'>
					<div className='shopTile' onClick={() => this.internalNav('gallery/wedding-bands/womens')}>
						<div className='shopImg'>
							<img src='https://ddw2.diamondsdirect.com/img/promopages/holiday2022/landing/studs.jpg' />
						</div>
						<div className='shopTileButton'><div>Shop Wedding Bands</div></div>
					</div>
					<div className='shopTile' onClick={() => this.internalNav('gallery/engagement-rings?mode=setting')}>
						<div className='shopImg'>
							<img src='https://ddw2.diamondsdirect.com/img/promopages/holiday2022/landing/engagement.jpg' />
						</div>
						<div className='shopTileButton'><div>Shop Engagement</div></div>
					</div>
					<div className='shopTile' onClick={() => this.internalNav('gallery/fine-jewelry?type=ring,earring,necklace,bracelet')}>
						<div className='shopImg'>
							<img src='https://ddw2.diamondsdirect.com/img/promopages/holiday2022/landing/pendants.jpg' />
						</div>
						<div className='shopTileButton'><div>Shop Fashion</div></div>
					</div>
				</div>
			</div>

			<div className='titleSection'>
				<div className='title1'>It’s not too late to shop for the perfect holiday gift!</div>
				<div className='title2'>25% OFF ALL EARRINGS<sup>*</sup></div>
				<div className='title3'>Ready to wrap for the one you love!</div>
				<div className='title4'>Available online now or in stores December 9 -11</div>
				<div className='titleAction' onClick={() => this.internalNav('gallery/fine-jewelry?type=earring')}>Shop Earrings</div>	
			</div>


			<div className='looksSection'>
				<div className='looksWrapper'>
					<img className='desktop600' src='https://ddw2.diamondsdirect.com/img/promopages/earring2022/lander/edit.jpg' />
					<img className='mobile600' src='https://ddw2.diamondsdirect.com/img/promopages/earring2022/lander/edit_m.jpg' />
					<Link to={'/diamond-studs'} className={'lb lb1'}></Link>
					<Link to={'/jewelry/PRLFE00688'} className={'lb lb2'}></Link>
					<Link to={'/jewelry/EFAND18662'} className={'lb lb3'}></Link>
					<Link to={'/jewelry/EFAND17506'} className={'lb lb4'}></Link>
				</div>
			</div>

			<div className='formSection'>		
				<div className='formBoxWrapper'>
					<div className='formInnerWrapper'>
						<div className='formP'>Walk-in visits are always welcome! But if you'd prefer to set up an appointment online or in-store, please use the form below and we will follow up to confirm!</div>
						<div className='formWrapper'>
							<div className='formInputWrapper'>
								<input 
									className={this.state.errorName ? 'textInput error' : 'textInput'}
									type='text' 
									placeholder='Full Name*'
									value={this.state.inputName}
                	onChange={::this.changeName} />
							</div>
							<div className='formInputWrapper'>
								<input 
									className={this.state.errorEmail ? 'textInput error' : 'textInput'}
									type='email' 
									placeholder='Email Address*'
									value={this.state.inputEmail}
                	onChange={::this.changeEmail} />
							</div>
							<div className='formInputWrapper'>
								<input 
									className={this.state.errorPhone ? 'textInput error' : 'textInput'}
									type='text' 
									placeholder='Telephone'
									value={this.state.inputPhone}
                	onChange={::this.changePhone} />
							</div>
							<div className='formInputWrapper'>
								<RhinoSelect
	                selectClass={'summerSelect'}
	                required={true}
	                value={this.state.inputLocation}
	                options={this.state.locations}
	                changeMethod={(evt) => this.changeLocation(evt)}
	                error={this.state.errorLocation !== null} />
							</div>
							<div className='formActionRow'>
								<button className={'formAction'} onClick={::this.submitContactRequest}>Request an appointment</button>
							</div>
						</div>
					</div>
				</div>
			</div>

			<div className='midHeaderSection' onClick={() => this.internalNav('financing')}>
				<div className='midHeaderSectionWrapper'>
					<img className='desktop600' src='https://ddw2.diamondsdirect.com/img/promopages/earring2022/lander/dec_fi.jpg' />
					<img className='mobile600' src='https://ddw2.diamondsdirect.com/img/promopages/earring2022/lander/dec_fi_m.jpg' />
				</div>
			</div>

			<div className='ggSection'>
				<div className='ggTitle'>
					<img src='https://ddw2.diamondsdirect.com/img/promopages/earring2022/lander/ee_gg.svg' />
				</div>
				<div className='ggLine'>
					<img src='https://ddw2.diamondsdirect.com/img/promopages/holiday2022/landing/gg_iconline.svg' />
				</div>

				<div className='ggP'>Shop our favorite gift guide items in our showrooms or from the comfort of your own home and make this a season to remember!</div>
				<div className='ggButton' onClick={::this.giftsNav}>Shop Holiday Gifts</div>

				<div className='ggItemRow'>
					<Link to={'/jewelry/BLDXL18079'} className={'ggItem'}>
						<div className={'ggItemImg ggItemImg1'}></div>
						<div className={'ggItemLabel'}>Emerald Diamond Halo Ring</div>
					</Link>
					<Link to={'/jewelry/ECLST07283'} className={'ggItem'}>
						<div className={'ggItemImg ggItemImg2'}></div>
						<div className={'ggItemLabel'}>Sapphire and Diamond Hoop Earrings</div>
					</Link>
					<Link to={'/jewelry/NFANC22315'} className={'ggItem'}>
						<div className={'ggItemImg ggItemImg3'}></div>
						<div className={'ggItemLabel'}>Diamond Dangle Station Necklace</div>
					</Link>
					<Link to={'/band/BLDSM23102'} className={'ggItem'}>
						<div className={'ggItemImg ggItemImg4'}></div>
						<div className={'ggItemLabel'}>Inlay Matte Diamond Band</div>
					</Link>
				</div>
			</div>

			<div className='legalSection'>
				<div className='legalInnerWrapper'>*Discount excludes GIA certified diamonds and price-protected designer lines. Cannot be combined with other offers. Inquire for details.</div>
			</div>
			
		</div>;
	}
}
export default Earring2022;

function mapStateToProps(state) {
  return {

  };
}

export const Earring2022Container = connect(
  mapStateToProps,
  allActionCreators
)(Earring2022);


// WEBPACK FOOTER //
// ./src/components/views/promopages/earring2022/Earring2022.jsx